module.exports = "/roster/components/rosterActionsComponent-a8b9f1.html";